import ErrorBoundary from 'shared/components/ErrorBoundary';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

import styles from './styles.css';

const OnDisplay = props => {
	const { onDisplay, productStore } = props;
	return onDisplay ? (
		<ErrorBoundary>
			<div className={classNames(styles['product-spacer'], styles['on-display'])}>
				<b style={{ color: 'green', fontSize: '1.3em' }}>On Display - {productStore}</b>
			</div>
		</ErrorBoundary>
	) : null;
};

OnDisplay.defaultProps = {
	onDisplay: false,
	productStore: '',
};

OnDisplay.propTypes = {
	onDisplay: PropTypes.bool,
	productStore: PropTypes.string,
};

export default OnDisplay;
